import { createStore } from 'vuex'

import authModule from './auth/index.js'
import fileModule from './file/index.js'
import sdkModule from './sdk/index.js'
import userModule from './user/index.js'

export default createStore({
  modules: {
    auth: authModule,
    file: fileModule,
    sdk: sdkModule,
    user: userModule,
  }
})
